import { render, staticRenderFns } from "./ViewReportPage.vue?vue&type=template&id=613a6df5&scoped=true"
import script from "./ViewReportPage.vue?vue&type=script&lang=js"
export * from "./ViewReportPage.vue?vue&type=script&lang=js"
import style0 from "./ViewReportPage.vue?vue&type=style&index=0&id=613a6df5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613a6df5",
  null
  
)

export default component.exports